<div [ngClass]="sizeClass">
  <img src="assets/img/ficha.png" alt="Vale chance" />
</div>
